import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss', './spinner.component.rtl.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SpinnerComponent {


  

}
